export default {
    setup_title: "Setup",
    setup_leads_setting: "Leads Setting",
    setup_marketing_source: "Marketing Source",
    setup_quality: "Quality",
    setup_cta: "CTA (Call to Action)",
    setup_btn_call_link: "Btn Call Link",
    setup_create_call_link: "Create Call Link",
    setup_smart_card: "Smart Card",
    setup_org_info: "Organization Information",
    setup_forms_setting: "Forms Setting",
    setup_list_of_forms: "List of Forms",
    setup_alert_response: "Alert & Response",
    setup_notifications: "Notifications",
    setup_sms_form_noti: "SMS Form Notification",
    setup_general_setting: "General Setting",
    setup_language: "Language",
}
